import React from 'react';
import {Input, Row, Col, Button} from "../../Common/reactstrap/lib";
export default function EmailInputBlock() {
  return (
    <div className="mb-4">
      <h3>Укажите адрес электронной почты</h3>
      <Row cLassName="m-y-0_5">
        <Col sm="4">
          <Row>
            <Col sm="7">
              <Input className="m-r-0_5" type="email" />
            </Col>
            <Button>Отправить</Button>
          </Row>


        </Col>
      </Row>
      <p>Мы будем высылать вам уведомления о движении вашего заказа</p>
    </div>
  );
}



/** WEBPACK FOOTER **
 ** ./src/components/Cart/elements/EmailInputBlock.jsx
 **/